import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type AllInvoiceCollectionFragment = { __typename?: 'InvoiceCollection', id: string, name: string, scope: Types.InvoiceCollectionScope, invoice_email?: string | null, invoice_headline?: string | null, legal_name?: string | null, vat_number?: string | null, invoice_email_subject_prefix?: string | null, invoice_collection_debitor_account_number: number, billomat_client_id?: string | null, disable_automatic_partner_invoice_sending?: boolean | null, collapse_invoice_items?: boolean | null, store_ids?: Array<string | null> | null, type?: Types.StoreType | null, invoice_address?: { __typename?: 'Address', streetname?: string | null, streetno?: string | null, street_extra?: string | null, zip?: string | null, city?: string | null, country?: string | null } | null };

export const AllInvoiceCollectionFragmentDoc = gql`
    fragment AllInvoiceCollection on InvoiceCollection {
  id
  name
  scope
  invoice_email
  invoice_headline
  legal_name
  vat_number
  invoice_email_subject_prefix
  invoice_collection_debitor_account_number
  billomat_client_id
  disable_automatic_partner_invoice_sending
  collapse_invoice_items
  store_ids
  invoice_address {
    streetname
    streetno
    street_extra
    zip
    city
    country
  }
  type
}
    `;